import { createRoute } from "@tanstack/react-router";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { EmployeesRegistry } from "@/pages/registries/EmployeesRegistry";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/employees",
  component: EmployeesRoute,
});

function EmployeesRoute() {
  return (
    <AuthGuard>
      <EmployeesRegistry />
    </AuthGuard>
  );
}
